import { render } from "./TriggerModal.vue?vue&type=template&id=873e58ae&scoped=true"
import script from "./TriggerModal.vue?vue&type=script&lang=js"
export * from "./TriggerModal.vue?vue&type=script&lang=js"

import "./TriggerModal.vue?vue&type=style&index=0&id=873e58ae&scoped=true&lang=css"

import exportComponent from "/Users/zvonkobiskup/Code/op3/wp-content/plugins/op-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-873e58ae"]])

export default __exports__